import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 3a7 7 0 0 1 6.95 6.155a6.97 6.97 0 0 1 5.05 -2.155h3a1 1 0 0 1 1 1v1a7 7 0 0 1 -7 7h-2v4a1 1 0 0 1 -2 0v-7h-2a7 7 0 0 1 -7 -7v-2a1 1 0 0 1 1 -1z","key":"svg-0"}]]

/**
 * IconSeedlingFilled
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0iY3VycmVudENvbG9yIgogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb25zLXRhYmxlci1maWxsZWQgaWNvbi10YWJsZXItc2VlZGxpbmciCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTYgM2E3IDcgMCAwIDEgNi45NSA2LjE1NWE2Ljk3IDYuOTcgMCAwIDEgNS4wNSAtMi4xNTVoM2ExIDEgMCAwIDEgMSAxdjFhNyA3IDAgMCAxIC03IDdoLTJ2NGExIDEgMCAwIDEgLTIgMHYtN2gtMmE3IDcgMCAwIDEgLTcgLTd2LTJhMSAxIDAgMCAxIDEgLTF6IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/seedling-filled
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconSeedlingFilled = createReactComponent('filled', 'seedling-filled', 'SeedlingFilled', __iconNode);

export default IconSeedlingFilled;